<template>
    <v-card
            class="notification-container-panel"
            :class="notificationContainerPanelClass"
    >
        <v-card-title v-if="dismittedNotificationLength <= 0">
            <v-icon
                    large
                    left
            >
                mdi-thumb-up
            </v-icon>
            <span class="title font-weight-light">{{ $t('globalControls.notifications.noNotifications') }}</span>
        </v-card-title>
        <v-card-text v-show="dismittedNotificationLength > 0" class="notification-container-text pa-0 ma-0">
        <v-flex shrink
                v-for="notification in state"
                class="notification-subcontainer-panel"
        >
            <Notification
                    v-show="(!notification.dismissed)"
                    :notification="notification"
            />
        </v-flex>
        </v-card-text>
        <v-card-actions v-show="dismittedNotificationLength > 0">
            <v-spacer/>
            <v-btn
                    flat
                    @click="deleteAllNotifications()"
            >
                {{ $t('globalControls.notifications.deleteAll') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import Notification from "@/components/GlobalControls/Notifications/Notification";
    import NotificationService from "@/helpers/NotificationService";

    export default {
        name: "GlobalNotificationsPanel",
        components: {Notification,},
        props: ["state",],
        data() {
            return {};
        },
        computed: {
            dismittedNotificationLength() {
                return this.state.filter(notification => !notification.dismissed).length;
            },
            notificationContainerPanelClass() {
                let styleClass = "";
                if (this.$vuetify.breakpoint.name === "xs") {
                    styleClass = "notification-container-panel-xs";
                } else {
                    styleClass = "notification-container-panel-sm";
                }
                return styleClass;
            },
        },
        methods: {
            deleteAllNotifications() {
                NotificationService.dismissAllNotifications();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notification-container-panel {
        z-index: 8; // same of v-menu
        border-radius: 5px;
        background-color: white;
        position: fixed;
        padding: 2px;
        top: 48px;
        right: 8px;
        margin-top: 10px;
    }

    .notification-container-panel-sm {
        width: 404px;
    }
    .notification-container-panel-xs {
        left: 0;
        right: 0;
        margin-left: 8px;
        margin-right: 8px;
        width: calc(100% - 16px);
    }


    .notification-subcontainer-panel {
        border-radius: 5px;
        margin-bottom: 5px;
    }
    .notification-container-text {
        max-height: 60vh;
        overflow-y: auto;
    }

</style>
